import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

@Component({
  selector: 'app-relato',
  templateUrl: './relato.component.html',
  styleUrls: ['./relato.component.scss']
})
export class RelatoComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  serasaObj;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    console.log(this.serasaObj);
  }

  closeModal() {
    this.close();
  }

  sumTotais(obj) {
    let total = 0;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i].Valor) {
        total += obj[i].Valor;
      }
    }
    return total;
  }

  sumCapitais(obj) {
    let total = 0;
    for (var i = 0; i < obj.length; i++) {
      if (obj[i].Capital) {
        total += obj[i].Capital;
      }
    }
    return total;
  }
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/relato/relato.component.ts